// *******************************************************
// FUNCTION:    parsedReloadingContentNext
// PARAMETERS:  type (the image type set we are parsing through)
// DESCRIPTION: Control for parsing to the next available photoviewer image
// *******************************************************
jQuery(function($) {
    function parsedReloadingContentNext(type) {
	var currentImage = $('.js-parsed-' + type + '-reloading-content-container').find('.current');
	var currentIndex = currentImage.data('image');
	var totalImages = currentImage.data('total-images');
	var newIndex = 1;

	if (currentIndex !== totalImages) {
		newIndex = currentIndex + 1;
	}

	var newImage = $('.js-parsed-' + type + '-reloading-content-container').find("[data-image='" + newIndex + "']");

		currentImage.fadeOut($.extend({}, {duration: 300, queue: false}, {
			complete: function() {
				currentImage.removeClass('current');
				currentImage.css('opacity', '');
				newImage.fadeIn($.extend({}, {duration: 300, queue: false}, {
					complete: function() {
						newImage.addClass('current');
						newImage.css('opacity', '');
					}
				}));
			}
		}));
    }
    window.parsedReloadingContentNext = parsedReloadingContentNext;
});

// *******************************************************
// FUNCTION:    parsedReloadingContentPrev
// PARAMETERS:  type (the image type set we are parsing through)
// DESCRIPTION: Control for parsing to the previous available photoviewer image
// *******************************************************
jQuery(function($) {
    function parsedReloadingContentPrev(type) {
		var currentImage = $('.js-parsed-' + type + '-reloading-content-container').find('.current');
		var currentIndex = currentImage.data('image');
		var totalImages = currentImage.data('total-images');
		var newIndex = totalImages;

		if (currentIndex !== 1) {
			newIndex = currentIndex - 1;
		}

		var newImage = $('.js-parsed-' + type + '-reloading-content-container').find("[data-image='" + newIndex + "']");

		currentImage.fadeOut($.extend({}, {duration: 300, queue: false}, {
			complete: function() {
				currentImage.removeClass('current');
				currentImage.css('opacity', '');
				newImage.fadeIn($.extend({}, {duration: 300, queue: false}, {
					complete: function() {
						newImage.addClass('current');
						newImage.css('opacity', '');
					}
				}));
			}
		}));
    }
    window.parsedReloadingContentPrev = parsedReloadingContentPrev;
});